var _rect, _rect2, _g, _path, _rect3, _g2, _path2, _path3, _rect4, _g3, _path4, _rect5, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTube2Dry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 18,
    viewBox: "0 0 63 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 616"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1074",
    x: 10,
    y: 18,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 10 18)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 617"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_133515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 2,
    width: 38,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1075",
    x: 12,
    y: 16,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 12 16)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_133515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1076",
    x: 12,
    y: 16,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 12 16)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1077",
    d: "M18.8846 14.2788C15.0823 14.2788 12 11.1965 12 7.39423C12 3.59198 15.0823 0.509645 18.8846 0.509645L50.9744 0.509644L50.9744 10.2788C50.9744 12.4879 49.1835 14.2788 46.9744 14.2788L18.8846 14.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1078",
    d: "M10 4L10 1L51 1L51 4L10 4Z",
    fill: "#F2F7FC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 615"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1079",
    d: "M4.10711 13.0282C3.44991 13.5369 2.49506 13.0685 2.49506 12.2374L2.49506 6.20826C2.49506 5.4106 3.38316 4.934 4.04786 5.37495L8.10892 8.06898L8.10892 9.93105L4.10711 13.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 619"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_133515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 3,
    height: 6
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1078_2",
    x: 10.604,
    y: 6.82764,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 10.604 6.82764)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_133515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1084",
    x: 10.604,
    y: 6.82764,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 10.604 6.82764)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1082",
    d: "M8.80983 6.20691C9.13116 6.20691 9.40985 6.42552 9.46599 6.7419C9.55585 7.24828 9.66832 8.06819 9.66832 9.00001C9.66832 9.93184 9.55585 10.7517 9.46599 11.2581C9.40985 11.5745 9.13116 11.7931 8.80983 11.7931C8.42273 11.7931 8.10891 11.4793 8.10891 11.0922L8.10891 6.90783C8.10891 6.52072 8.42273 6.20691 8.80983 6.20691Z",
    fill: "#EEEEEE"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1081",
    d: "M1.35744 12.515C0.702677 12.7656 1.23021e-07 12.2822 2.37653e-07 11.5811L9.96796e-07 6.93827C1.10671e-06 6.26604 0.64999 5.78528 1.29276 5.98208L8.10891 8.06903L8.10891 9.9311L1.35744 12.515Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 618"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1079_2",
    d: "M58.8929 13.0282C59.5501 13.5369 60.5049 13.0685 60.5049 12.2374L60.5049 6.20826C60.5049 5.4106 59.6168 4.934 58.9521 5.37495L54.8911 8.06898L54.8911 9.93105L58.8929 13.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 619_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_428_133515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 6,
    width: 3,
    height: 6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1078_3",
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 52.396 6.82764)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_428_133515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1084_2",
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 52.396 6.82764)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1082_2",
    d: "M54.1902 6.20691C53.8688 6.20691 53.5902 6.42552 53.534 6.7419C53.4441 7.24828 53.3317 8.06819 53.3317 9.00001C53.3317 9.93184 53.4441 10.7517 53.534 11.2581C53.5902 11.5745 53.8688 11.7931 54.1902 11.7931C54.5773 11.7931 54.8911 11.4793 54.8911 11.0922L54.8911 6.90783C54.8911 6.52072 54.5773 6.20691 54.1902 6.20691Z",
    fill: "#EEEEEE"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1081_2",
    d: "M61.6426 12.515C62.2973 12.7656 63 12.2822 63 11.5811L63 6.93827C63 6.26604 62.35 5.78528 61.7072 5.98208L54.8911 8.06903L54.8911 9.9311L61.6426 12.515Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1197",
    x: 38,
    width: 18,
    height: 12,
    transform: "rotate(90 38 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Number",
    transform: "translate(24.5 3.5)",
    fill: "#333333",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 12,
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4.39062,
    y: 9.7
  }, "2")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube2Dry);
export default __webpack_public_path__ + "static/media/tube2_dry.f703d5e5fd50c7114b7f9c5b4a1f651d.svg";
export { ForwardRef as ReactComponent };